// import Vue from 'vue'
// import { router } from '../router/index.js'
import axios from 'axios'
// import qs from 'qs'
// import { LS } from './ls'
let config = {
  // baseURL: '/api/',
  timeout: 10000,
  // `headers`选项是需要被发送的自定义请求头信息
  headers: {
    'Content-Type': 'application/json'
    // 'X-Requested-With': 'XMLHttpRequest',
    //   // 'Authorization': 'eae16526b553445f8d4f7de3d9d7c884'
  }
  // transformRequest: [function (data) {
  //   // 需要序列化数据，数据放到formdata
  //   return qs.stringify(data)
  // }]
}
const _axios = axios.create(config)
_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// 返回拦截器
_axios.interceptors.response.use(
  function (response) {
    // Do something
    return response
  },
  function (error) {
    const { status } = error.response
    if (status === 401) {
      location.href =
        '/app/shop/login?followup=' + encodeURIComponent(location.href)
    }
    // Do something with response error
    return Promise.reject(error)
  }
)

export const request = option => {
  return _axios(option).then(res => {
    if (res.status === 200) {
      return res.data
    } else {
      // let backUrl = location.href;
    }
  })
  // .catch(err => {
  //   // console.log(err)
  // })
}
